import { filters } from "components/Filters/Filters";
import { pagination } from "components/Pagination/Pagination";
import { Page } from "modules/Page";

import "./job-listings-page.scss";

export class JobListingsPage extends Page<typeof JobListingsPage> {
    static readonly className = "js-job-listings-page";

    private searchParams?: URLSearchParams;

    public init() {
        this.searchParams = new URLSearchParams(window.location.search);
        filters.init();
        filters.get(window.location.search);
        pagination.init();
        this.initMobileFilterButton();
        this.initRadiusFilter();
    }

    public initMobileFilterButton() {
        const mobileFilterButton = document.querySelector("#filter-mobile");
        const element = this.rootElement.querySelector(".open-positions");

        if (mobileFilterButton && element)
            element.insertAdjacentElement("beforeend", mobileFilterButton);
    }

    public initRadiusFilter() {
        const radiusFilterElement = this.rootElement.querySelector<HTMLInputElement>("#radius");
        const dl = radiusFilterElement?.closest("dl");
        const radiusFilterValueElement = this.rootElement.querySelector("#radius-value");
        const locationsFilterDiv = this.rootElement.querySelector<HTMLDivElement>("div[name='Locations']");

        if (!locationsFilterDiv || !radiusFilterElement || !radiusFilterValueElement || !dl) return;

        const radius = this.searchParams?.get("radius");

        if (radius) {
            radiusFilterElement.value = radius;
            radiusFilterValueElement.textContent = radius + " km";
        }

        this.observeLocationsFilter(locationsFilterDiv, dl);

        const selectedLocations = locationsFilterDiv.querySelectorAll(".checked");

        if (selectedLocations.length) {
            dl.querySelector(".filter-content")?.classList.add("active");
        } else {
            dl.querySelector(".filter-custom")?.classList.remove("active");
            dl.querySelector(".filter-content")?.classList.remove("active");
        }

        radiusFilterElement.addEventListener("input", (event) => {
            if (!(event.target instanceof HTMLInputElement)) return;

            radiusFilterValueElement.textContent = event.target.value + " km";
        });
    }

    private observeLocationsFilter(locationsFilterDiv: HTMLDivElement, dl: HTMLDListElement) {
        const config = { attributes: true, childList: true, subtree: true };

        const callback: MutationCallback = (mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    const selectedLocations = locationsFilterDiv.querySelectorAll(".checked");
                    if (!selectedLocations.length) {
                        dl.querySelector(".filter-content")?.classList.remove("active");
                    } else {
                        dl.querySelector(".filter-content")?.classList.add("active");
                    }
                    return;
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(locationsFilterDiv, config);
    }
}